import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {  Router } from "@angular/router";
import { Subject } from "rxjs";


@Component({
  selector: 'app-design-sprint',
  templateUrl: './design-sprint.component.html',
  standalone:false,
  styleUrls: ['./design-sprint.component.scss']
})
export class DesignSprintComponent implements OnInit {
  tinNumber:boolean = false;
  
  

  constructor(private router:Router, private location: Location) { }
  back() {
    this.location.back()
  }

  ngOnInit(): void {
  }

}
